<template>
  <div class="empty">
    <div v-if="path == 'integralSub'" class="integral">
      <div class="intCenter">
        <img src="../../assets/images/integral.png" />
        <p>啊哦，积分没有任何变动～</p>
        <!--<button class="redbtn" @click="go">去看看</button>-->
      </div>
    </div>
    <div v-if="path == 'noAddress'" class="integral">
      <div class="intCenter">
        <img src="../../assets/images/noaddress.png" />
        <p>您还没有相关地址哦～</p>
        <button class="redbtn" @click="addAddress">添加地址</button>
      </div>
    </div>
    <div v-if="path == 'noCart'" class="integral">
      <div class="intCenter">
        <img src="../../assets/images/nocartd.png" />
        <p>购物车快饿瘪了T.T</p>
        <button class="redbtn" @click="stroll">去逛逛</button>
      </div>
    </div>
    <div v-if="path == 'noCollect'" class="integral">
      <div class="intCenter">
        <img src="../../assets/images/nocollect.png" />
        <p>您还没有收藏任何商品哦～</p>
        <button class="redbtn" @click="stroll">去逛逛</button>
      </div>
    </div>
    <div v-if="path == 'noCoupon'" class="coupon">
      <div class="nocoupon">
        <img src="../../assets/images/nocoupon.png" />
        <p>您还没有任何{{ type == 0 ? '现金劵' : '产品劵' }}～</p>
      </div>
    </div>
    <div v-if="path == 'noIntegral'" class="integral">
      <div class="intCenter">
        <img src="../../assets/images/emptyorder.png" />
        <p style="white-space: nowrap">
          {{
            noDatades == 1
              ? '啊哦，暂时没有可兑换的优惠券呦~'
              : noDatades == 2
              ? '糟糕！没搜到相关内容哦～'
              : noDatades == 3
              ? '哇哦，暂无草稿哦~'
              : noDatades == 4
              ? '糟糕！没有相关内容哦～'
              : '啊哦，暂时没有可兑换的商品呦~'
          }}
        </p>
        <!--社区搜索-->
        <p
          class="go f14"
          :class="{ noDatades: noDatades == 3 }"
          v-if="noDatades == 2 || noDatades == 3 || noDatades == 4"
          style="white-space: nowrap"
          @click="goCommunity(noDatades == 4 ? 2 : 0)"
        >
          {{
            noDatades == 2 || noDatades == 4 ? '去社区逛逛' : noDatades == 3 ? '去发点有趣的事' : ''
          }}
          <van-icon name="arrow" />
        </p>
      </div>
    </div>
    <div v-if="path == 'noFans'" class="integral">
      <div class="intCenter">
        <img src="/static/images/community/user-icon-nothing.png" />
        <p style="white-space: nowrap">
          {{ noDatades == 1 ? '还没有关注用户哦～' : '还没有被关注哦～' }}
        </p>
        <!--社区搜索-->
        <p class="go f14" style="white-space: nowrap" @click="goCommunity(1)">
          {{ noDatades == 1 ? '去找找有趣的人' : '去发点有趣的事' }}
          <van-icon name="arrow" />
        </p>
      </div>
    </div>
    <div v-if="path == 'noMsg'" class="integral">
      <div class="intCenter">
        <img src="/static/images/community/user-icon-nothing.png" />
        <p style="white-space: nowrap">
          {{
            noDatades == 1
              ? '还没有收到评论或回复哦～'
              : noDatades == 2
              ? '还没有收到点赞或收藏哦～'
              : '暂无内容哦～'
          }}
        </p>
        <!--社区搜索-->
        <p class="go f14" style="white-space: nowrap" @click="goCommunity(2)">
          去社区逛逛
          <van-icon name="arrow" />
        </p>
      </div>
    </div>
    <div v-if="path == 'noData'" class="integral">
      <div class="intCenter">
        <img src="../../assets/images/emptyorder.png" />
        <p>暂无数据</p>
      </div>
    </div>
    <div v-if="path == 'noOrder'" class="integral">
      <div class="intCenter">
        <img src="../../assets/images/emptyorder.png" />
        <p>啊哦～您还没有相关订单</p>
      </div>
    </div>
    <div v-if="path == 'noCommunity'" class="integral">
      <div class="intCenter">
        <img src="../../assets/images/emptyorder.png" />
        <p>啊哦～您还没有相关测评</p>
      </div>
    </div>
    <div v-if="path == 'noPrize'" class="integral">
      <div class="intCenter">
        <img src="../../assets/images/noprize.png" />
        <p>您没有任何奖品～</p>
      </div>
    </div>
    <div v-if="path == 'noSearch' || path == 'noFootprint'" class="integral">
      <div class="intCenter">
        <img src="../../assets/images/nosearch.png" />
        <p v-if="content" v-html="content"></p>
        <p v-else>
          {{ path == 'noFootprint' ? '暂无商品浏览记录~' : '啊哦，您所搜索的内容不存在' }}
        </p>
      </div>
    </div>
    <div v-if="path == 'successPhone'" class="updBoxFa" style="height: 100%">
      <div class="updBox">
        <img class="tagsRight" src="../../assets/images/success.jpg" />
        <p>提交成功</p>
        <span>已提交申请，核实有效后奖励积分</span>
      </div>
    </div>
    <div v-if="path == 'applyrecord'" class="integral" style="border-radius: 0.08rem;">
      <div class="intCenter" style="top: 30%;">
        <img src="/static/images/newproducttrial/new_product-apply_record-empty@2x.png" />
        <p style="margin: 0.16rem 0 0.08rem;">你还没有申请过商品哦～</p>
        <button class="redbtn" @click="goapply">立即申请</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'integralSub',
  props: ['isOpenSign', 'path', 'type', 'noDatades', 'content'],
  methods: {
    go() {
      if (this.isOpenSign == 0) {
        this.$router.push('/invfriends')
      } else if (this.isOpenSign == 1) {
        this.$router.push('/percen')
      }
    },
    addAddress: function() {
      var obj = this.$router.history.current.query
      obj.type = 'admin'
      this.$router.push({
        path: '/addadd',
        query: obj
      })
    },
    stroll: function() {
      this.$router.push({
        path: '/classification',
        query: {
          type: 'inside'
        }
      })
    },
    goCommunity: function(type) {
      if (type == 0) {
        if (this.noDatades == 2) {
          this.$router.go(-2)
        } else if (this.noDatades == 3) {
          this.$router.replace({
            path: '/communityevaluation'
          })
        }
      } else if (type == 1) {
        if (this.noDatades == 1) {
          this.$store.commit('COMMUNITY_TAB', 1)
          this.$router.push({
            path: '/community'
          })
        } else {
          this.$router.push({
            path: '/communityevaluation'
          })
        }
      } else {
        this.$store.commit('COMMUNITY_TAB', 1)
        console.log(this.$route)
        if (this.$route.path == '/community') {
          this.$router.go()
        } else {
          this.$router.push({
            path: '/community'
          })
        }
      }
    },
    goapply: function() {
      this.$router.push('/newproducthome')
    }
  }
}
</script>

<style scoped lang="scss">
.empty {
  height: 100%;
}
.integral {
  height: 100%;
  background: #fff;
  position: relative;
  .intCenter {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    img {
      width: 1.12rem;
      height: 1.12rem;
      margin: 0 auto;
    }
    p {
      font-size: 0.13rem;
      font-weight: 400;
      color: rgba(41, 41, 41, 1);
      line-height: 0.18rem;
      margin-top: 0.23rem;
      margin-bottom: 0.96rem;
      text-align: center;
      &.go {
        color: #fc0324;
        position: relative;
        top: -0.9rem;
        text-align: center;
        line-height: 0.14rem;
        .van-icon,
        .van-icon::before {
          vertical-align: bottom;
        }
        &.noDatades {
          top: -0.8rem;
        }
      }
    }
    .redbtn {
      outline: none;
      margin: 0 auto;
      display: block;
      background: none;
      min-width: 1.09rem;
      border-radius: 0.2rem;
      padding: 0.08rem 0;
      border: 1px solid rgba(252, 3, 36, 1);
      font-size: 0.14rem;
      font-weight: 400;
      color: rgba(252, 3, 36, 1);
      line-height: 0.2rem;
    }
  }
}
.coupon {
  height: 100%;
  background: #fff;
  position: relative;
  .nocoupon {
    position: absolute;
    left: 50%;
    top: 0.81rem;
    transform: translateX(-50%);
    -o-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    img {
      width: 1.12rem;
      height: 1.12rem;
      margin: 0 auto;
    }
    p {
      font-size: 0.13rem;
      font-weight: 400;
      color: rgba(41, 41, 41, 1);
      line-height: 0.18rem;
      margin-top: 0.23rem;
      margin-bottom: 0.96rem;
    }
  }
}
.updBoxFa {
  background: #fff;
  display: -webkit-flex;
  display: -ms-flex;
  display: -moz-flex;
  display: -o-flex;
  display: flex;
  justify-content: center;
  -webkit-justify-content: center;
  -moz-justify-content: center;
  -ms-justify-content: center;
  -o-justify-content: center;
  align-items: center;
  -webkit-align-items: center;
  -o-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  .updBox {
    .tagsRight {
      width: 1.01rem;
      height: 1.01rem;
      margin: -0.45rem auto 0.45rem;
    }
    p {
      color: #444;
      font-size: 0.21rem;
      text-align: center;
      margin-bottom: 0.04rem;
    }
    span {
      display: block;
      color: #6c6c6c;
      font-size: 0.13rem;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emptypage/empty.vue